// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconToGo = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path fillRule="evenodd" d="M8 9v2h2V9h4v2h2V9h2v11H4v2h16V7h-4V6a4 4 0 00-8 0v1H4v3h2V9zm2-3a2 2 0 114 0v1h-4z" />,
    <path d="M0 14v-2h8v2zm0 4h6v-2H0z" />
  );
export default SvgIconToGo;
